import React from 'react';
import ChatBox from '../../components/ChatBox';

export default function UserChat() {
  return (
    <div>
      <div className="topbar">
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#111827', fontFamily: 'Poppins, sans-serif' }}>Chat Support</h1>
          <p style={{ fontSize: 13, color: '#6b7280' }}>Send queries to the admin team in real-time</p>
        </div>
      </div>
      <div className="page-content">
        <div style={{ marginBottom: 16, padding: '12px 16px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, fontSize: 13, color: '#15803d' }}>
          💡 <strong>Tip:</strong> Type your query and press Enter or click the send button. Admin team will respond shortly.
        </div>
        <ChatBox />
      </div>
    </div>
  );
}
